import React, { useState, useEffect } from "react";
import axios from "axios";
import categoriesData from "../../../jsonData/categoryData.json";
import AdmissionTest from "../../../jsonData/AdmissionTest.json";
import BanglaVersion from "../../../jsonData/BanglaVersion.json";
import EnglishVersion from "../../../jsonData/EnglishVersion.json";
import EnglishMedium from "../../../jsonData/EnglishMedium.json";
import MadrasaMedium from "../../../jsonData/MadrasaMedium.json";
import ReligiousStudies from "../../../jsonData/ReligiousStudies.json";
import Arts from "../../../jsonData/arts.json";
import TestPreparation from "../../../jsonData/TestPreparation.json";
import "./jobBoardGreen.css";
import { Link } from "react-router-dom";
import JobBoardLoader from "../../Shared/pageLoaderGreen/JobBoardLoader";

// Map categories to subjects
const categorySubjects = {
  BanglaVersion: BanglaVersion,
  EnglishVersion: EnglishVersion,
  EnglishMedium: EnglishMedium,
  MadrasaMedium: MadrasaMedium,
  ReligiousStudies: ReligiousStudies,
  AdmissionTest: AdmissionTest,
  TestPreparation: TestPreparation,
  Arts: Arts,
};

const dateFormat = (dateString) => {
  // Array of month names
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Create a new Date object
  const date = new Date(dateString);

  // Extract the month, day, and year
  const month = monthNames[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  // Format the date as "Jul 31, 2024"
  return `${month} ${day}, ${year}`;
};


const JobsGreen = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [gender, setGender] = useState("any");
  const [city, setCity] = useState("");
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [categories, setCategories] = useState([]);
  const [jobId, setJobId] = useState(""); // Add this line to manage jobId input
  const [totalJobs, setTotalJobs] = useState(0);  // Total number of jobs
  const [filteredJobsCount, setFilteredJobsCount] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setCategories(categoriesData);
  }, []);

  const [appliedFilters, setAppliedFilters] = useState({
    gender: "any",
    city: "",
    areas: [],
    startDate: "",
    endDate: "",
    subjects: [],
    categories: [],
  });

  useEffect(() => {
    if (selectedCategories.length > 0) {
      const newSubjects = selectedCategories.flatMap(
        (category) => categorySubjects[category] || []
      );
      setSubjects(newSubjects);
    } else {
      setSubjects([]);
      setSelectedSubjects([]);
    }
  }, [selectedCategories]);

  // Fetch and manage areas
  const [areas, setAreas] = useState([]);
  useEffect(() => {
    const fetchAreas = async () => {
      try {
        const response = await fetch("https://tutor-tree-server-1.vercel.app/allArea");
        const data = await response.json();
        setAreas(data);
      } catch (error) {
        console.error("Error fetching Areas:", error);
      }
    };
    fetchAreas();
  }, []);

  const [khulnaArea, setKhulnaArea] = useState([]);
  useEffect(() => {
    const fetchKhulnaArea = async () => {
      try {
        const response = await fetch("https://tutor-tree-server-1.vercel.app/khulnaArea");
        const data = await response.json();
        setKhulnaArea(data);
      } catch (error) {
        console.error("Error fetching Khulna Areas:", error);
      }
    };
    fetchKhulnaArea();
  }, []);

  const [chittagongArea, setChittagongArea] = useState([]);
  useEffect(() => {
    const fetchChittagongArea = async () => {
      try {
        const response = await fetch("https://tutor-tree-server-1.vercel.app/ChittagongArea");
        const data = await response.json();
        setChittagongArea(data);
      } catch (error) {
        console.error("Error fetching Chittagong Areas:", error);
      }
    };
    fetchChittagongArea();
  }, []);

  const [dhakaArea, setDhakaArea] = useState([]);
  useEffect(() => {
    const fetchDhakaArea = async () => {
      try {
        const response = await fetch("https://tutor-tree-server-1.vercel.app/DhakaArea");
        const data = await response.json();
        setDhakaArea(data);
      } catch (error) {
        console.error("Error fetching Dhaka Areas:", error);
      }
    };
    fetchDhakaArea();
  }, []);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get("https://tutor-tree-server-1.vercel.app/new-jobs-publish-job-board", {
          params: {
            page,
            limit: 10,
            ...appliedFilters,
            areas: selectedAreas.join(","),
            categories: selectedCategories.join(","),
            subjects: selectedSubjects.join(","),
            jobId, 
          },
        });
        setJobs(response.data.jobs);
        setTotalPages(response.data.pages);
        setTotalJobs(response.data.totalJobs);  // Set total jobs
        setFilteredJobsCount(response.data.filteredJobsCount);
        
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
  
    fetchJobs();
  }, [page, appliedFilters, jobId]); // Include jobId in the dependency array
  

  if (loading) return <div className="mt-20"><JobBoardLoader></JobBoardLoader></div>;
  // if (error) return <div>Error: {error}</div>;

  const handlePreviousPage = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleNextPage = () => {
    if (page < totalPages) setPage(page + 1);
  };

  const handleGenderChange = (e) => {
    setGender(e.target.value);
  };

  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setCity(selectedCity);

    setSelectedAreas([]);

    switch (selectedCity.toLowerCase()) {
      case "khulna":
        setAreas(khulnaArea);
        break;
      case "chittagong":
        setAreas(chittagongArea);
        break;
      case "dhaka":
        setAreas(dhakaArea);
        break;
      default:
        setAreas([]);
    }
  };

  const handleCategoryChange = (category) => {
    setSelectedCategories((prev) =>
      prev.includes(category)
        ? prev.filter((c) => c !== category)
        : [...prev, category]
    );
  };

  const handleSubjectChange = (subject) => {
    setSelectedSubjects((prev) =>
      prev.includes(subject)
        ? prev.filter((s) => s !== subject)
        : [...prev, subject]
    );
  };

  const handleAreaClick = (area) => {
    setSelectedAreas((prevSelectedAreas) =>
      prevSelectedAreas.includes(area)
        ? prevSelectedAreas.filter((a) => a !== area)
        : [...prevSelectedAreas, area]
    );
  };

  const handleRemoveArea = (area) => {
    setSelectedAreas((prevSelectedAreas) =>
      prevSelectedAreas.filter((a) => a !== area)
    );
  };

  const handleRemoveCategory = (category) => {
    setSelectedCategories((prevSelectedCategories) =>
      prevSelectedCategories.filter((c) => c !== category)
    );
  };

  const handleRemoveSubject = (subject) => {
    setSelectedSubjects((prevSelectedSubjects) =>
      prevSelectedSubjects.filter((s) => s !== subject)
    );
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const handleSearch = () => {
    setAppliedFilters({
      gender,
      city,
      areas: selectedAreas,
      startDate,
      endDate,
      categories: selectedCategories,
      subjects: selectedSubjects,
    });
    setPage(1); // Reset to the first page
  };

  const clearFilters = () => {
    setGender("any");
    setCity("");
    setSelectedAreas([]);
    setStartDate("");
    setEndDate("");
    setSelectedCategories([]);
    setSelectedSubjects([]);
    setAppliedFilters({
      gender: "any",
      city: "",
      areas: [],
      startDate: "",
      endDate: "",
      subjects: [],
      categories: [],
    });
    setPage(1); // Reset to the first page
  };
  const classMapping = {
    'Pre-Schooling': 'Pre-Schooling',
    'Play': 'Play',
    'Nursery': 'Nursery',
    'KG': 'KG',
    'BM1': 'Class 1',
    'BM2': 'Class 2',
    'BM3': 'Class 3',
    'BM4': 'Class 4',
    'BM5': 'Class 5',
    'BM6': 'Class 6',
    'BM7': 'Class 7',
    'BM8': 'Class 8',
    'BM9': 'Class 9',
    'BM10': 'Class 10',
    'BMHSC-1stYear': 'HSC-1st Year',
    'BMHSC-2ndYear': 'HSC-2nd Year',
    'EV1': 'Class 1',
    'EV2': 'Class 2',
    'EV3': 'Class 3',
    'EV4': 'Class 4',
    'EV5': 'Class 5',
    'EV6': 'Class 6',
    'EV7': 'Class 7',
    'EV8': 'Class 8',
    'EV9': 'Class 9',
    'EV10': 'Class 10',
    'EVHSC-1stYear': 'HSC-1st Year',
    'EVHSC-2stYear': 'HSC-2nd Year',
    'EM1': 'Class 1',
    'EM2': 'Class 2',
    'EM3': 'Class 3',
    'EM4': 'Class 4',
    'EM5': 'Class 5',
    'EM6': 'Class 6',
    'EM7': 'Class 7',
    'EM8': 'Class 8',
    'EM9': 'Class 9',
    'OLevel': 'OLevel',
    'ALevelAS': 'A Level (AS)',
    'ALevelA2': 'A Level (A2)',
    'EMHSC-2stYear': 'HSC-2nd Year',
    'Alim1': 'Class 1',
    'Alim2': 'Class 2',
    'Alim3': 'Class 3',
    'Alim4': 'Class 4',
    'Alim5': 'Class 5',
    'Alim6': 'Class 6',
    'Alim7': 'Class 7',
    'Alim8': 'Class 8',
    'Alim9': 'Class 9',
    'Alim10': 'Class 10',
    'Alim-1stYear': 'Alim-1st Year',
    'Alim-2stYear': 'Alim-2nd Year',
    'IslamicStudies': 'Islamic Studies',
    'HinduismStudies': 'Hinduism Studies',
    'BuddhismStudies': 'Buddhism Studies',
    'ChristianityStudies': 'Christianity Studies',
    'SchoolAdmissionTest': 'School Admission Test',
    'PublicUniversityAdmissionTest': 'Public University Admission Test',
    'PrivateUniversityAdmissionTest': 'Private University Admission Test',
    'MedicalCollegeAdmissionTest': 'Medical College Admission Test',
    'EngineeringUniversityAdmissionTest': 'Engineering University Admission Test',
    'Arts': 'Arts',
    'Music': 'Music',
    'InstrumentalMusic': 'Instrumental Music',
    'Dance': 'Dance',
    'Crafting': 'Crafting',
    'Recitation': 'Recitation',
    'TestPreparation': 'Test Preparation',
    'IELTS': 'IELTS',
    'TOEFL': 'TOEFL',
    'GRE': 'GRE',
    'GMAT': 'GMAT',
    'SAT': 'SAT',
    'GED': 'GED',
};
const addSpaceBeforeCapital = (text) => {
  // return text.replace(/([a-z])([A-Z])/g, '$1 $2');
};
const handleJobIdChange = (e) => {
  setJobId(e.target.value);
};
  return (
    <div className="">
      <div className="flex border-y dropdown-container sticky top-0 z-40 shadow-md border-green-700 justify-between items-center py-4 px-6 bg-green-100 w-full">
        <div className="flex flex-row items-center gap-5">
          <h1 className="font-roboto text-lg text-green-900">
            <span className="text-xl font-semibold font-montserrat">{filteredJobsCount} +</span>{" "}
            jobs found
          </h1>

          <div>
            <input 
            placeholder="Job Id"
            className="py-2 px-4 rounded text-md font-montserrat border-2 border-green-500"
            value={jobId}
            onChange={handleJobIdChange}
            />
     
          </div>
        </div>
        <div className="">
          <button
            onClick={toggleDropdown}
            className="text-white font-roboto text-lg px-4 py-2 rounded-xl bg-green-700 hover:bg-green-900 text-whit duration-300"
          >
            Filter
          </button>
          <div
            className={`dropdown-menu w-full  flex flex-col  ${
              isOpen ? "open shadow-md  w-full" : ""
            }`}
          >
            <div>
              <div className="grid grid-cols-2 gap-5 p-5">
                <div>
                  <div className="grid grid-cols-2 gap-2">
                    <div className="">
                      <label className="block mb-2 text-lg font-montserrat text-green-900">
                        Start Date
                      </label>
                      <input
                        type="date"
                        value={startDate}
                        onChange={handleStartDateChange}
                        className="w-full p-2 py-4 rounded-lg !border-2 border-green-300 text-lg font-montserrat text-green-900"
                      />
                    </div>

                    <div className="mb-4">
                      <label className="block mb-2 text-lg font-montserrat text-green-900">
                        End Date
                      </label>
                      <input
                        type="date"
                        value={endDate}
                        onChange={handleEndDateChange}
                        className="w-full p-2 py-4 rounded-lg !border-2 border-green-300 text-lg font-montserrat text-green-900"
                      />
                    </div>
                  </div>
                  <div className="">
                    <label className="block mb-2 text-lg font-montserrat text-green-900">
                      City
                    </label>
                    <select
                      value={city}
                      onChange={handleCityChange}
                      className="w-full p-2 py-4 mb-4 active:!border-green-900 rounded-lg !border-2 border-green-300 text-lg font-montserrat text-green-900"
                    >
                      <option value="">Any</option>
                      <option value="Khulna">Khulna</option>
                      <option value="Dhaka">Dhaka</option>
                      <option value="Chittagong">Chittagong</option>
                    </select>
                  </div>

                  <div>
                    <div className="mb-4">
                      <label className="block mb-2 text-lg font-montserrat text-green-900">
                        Category
                      </label>
                      <details className="dropdown w-full text-sm font-montserrat text-green-900 border-2 border-green-300 rounded-lg">
                        <summary className="btn hover:bg-transparent flex justify-start bg-transparent w-full border-none m-1 !text-sm !font-montserrat font-thin !text-green-900">
                          {selectedCategories.length > 0 ? (
                            <div className="flex flex-wrap gap-2">
                              {selectedCategories.map((category) => (
                                <div
                                  key={category}
                                  className="px-2 py-1 flex items-center rounded-full justify-between border-2 border-green-700"
                                >
                                  <span className="text-sm font-montserrat text-green-900">
                                    {category}
                                  </span>
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleRemoveCategory(category)
                                    }
                                    className="ml-2 text-md text-white bg-green-700 rounded-full w-5 h-5  flex items-center justify-center"
                                  >
                                    X
                                  </button>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div>
                              <h1 className="text-lg font-montserrat text-green-900 lowercase">
                                Select Category
                              </h1>
                            </div>
                          )}
                        </summary>
                        <ul className="menu slideDropdown dropdown-content bg-green-100 h-56 border-none overflow-scroll rounded-box p-2 shadow">
                          {categories.map((cat) => (
                            <li key={cat.id}>
                              <button
                                type="button"
                                className={`flex items-center ${
                                  selectedCategories.includes(cat.code)
                                    ? "bg-green-600 m-1 font-montserrat text-white text-lg"
                                    : "bg-green-100 m-1 font-montserrat text-green-900 text-lg"
                                } px-4 py-2`}
                                onClick={() => handleCategoryChange(cat.code)}
                              >
                                {cat.category}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </details>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="">
                    <label className="block mb-2 text-lg font-montserrat text-green-900">
                      Gender
                    </label>
                    <select
                      value={gender}
                      onChange={handleGenderChange}
                      className="w-full p-2 py-4 mb-4 active:!border-green-900 rounded-lg !border-2 border-green-300 text-lg font-montserrat text-green-900"
                    >
                      <option value="any">Any</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </select>
                  </div>
                  <div>
                    <div className="">
                      <label className="block mb-2 text-lg font-montserrat text-green-900">
                        Area
                      </label>
                      <details className="dropdown w-full text-sm font-montserrat text-green-900 border-2 border-green-300 rounded-lg">
                        <summary className="btn hover:bg-transparent flex justify-start bg-transparent w-full border-none m-1 !text-sm !font-montserrat font-thin !text-green-900">
                          {selectedAreas.length > 0 ? (
                            <div className="flex flex-wrap gap-2">
                              {selectedAreas.map((area) => (
                                <div
                                  key={area}
                                  className="px-2 py-1 flex items-center rounded-full justify-between border-2 border-green-700"
                                >
                                  <span>{area}</span>
                                  <button
                                    type="button"
                                    onClick={() => handleRemoveArea(area)}
                                    className="ml-2 text-md text-white fon bg-green-700 rounded-full w-5 h-5  flex items-center justify-center"
                                  >
                                    X
                                  </button>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div>
                              <h1 className="text-lg font-montserrat text-green-900 lowercase">
                                Select Area
                              </h1>
                            </div>
                          )}
                        </summary>
                        <ul className="menu slideDropdown dropdown-content bg-green-100 h-56 border-none overflow-scroll rounded-box p-2 shadow">
                          {areas.map((area) => (
                            <li key={area._id}>
                              <button
                                type="button"
                                className={`flex items-center mr-4 ${
                                  selectedAreas.includes(area.area)
                                    ? "bg-green-600 m-1 font-montserrat text-white text-lg"
                                    : "bg-green-100 m-1 font-montserrat text-green-900 text-lg"
                                } px-4 py-2`}
                                onClick={() => handleAreaClick(area.area)}
                              >
                                {area.area}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </details>
                    </div>
                  </div>
                  <div>
                    <div className="mb-4"></div>

                    <div className="mb-4">
                      <label className="block mb-2 text-lg font-montserrat text-green-900">
                        Subject
                      </label>
                      <details className="dropdown w-full text-sm font-montserrat text-green-900 border-2 border-green-300 rounded-lg">
                        <summary className="btn hover:bg-transparent flex justify-start bg-transparent w-full border-none m-1 !text-sm !font-montserrat font-thin !text-green-900">
                          {subjects.length > 0 ? (
                            <div className="flex flex-wrap gap-2">
                              {selectedSubjects.map((subject) => (
                                <div
                                  key={subject}
                                  className="px-2 py-1 flex items-center rounded-full justify-between border-2 border-green-700"
                                >
                                  <span>{subject}</span>
                                  <button
                                    type="button"
                                    onClick={() => handleRemoveSubject(subject)}
                                    className="ml-2 text-md text-white fon bg-green-700 rounded-full w-5 h-5  flex items-center justify-center"
                                  >
                                    X
                                  </button>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div>
                              <h1 className="text-lg font-montserrat text-green-900 lowercase">
                                Select Subjects
                              </h1>
                            </div>
                          )}
                        </summary>
                        <ul className="menu slideDropdown dropdown-content bg-green-100 h-56 border-none overflow-scroll rounded-box p-2 shadow">
                          {subjects.map((sub) => (
                            <li key={sub.code}>
                              <button
                                type="button"
                                className={`flex items-center mr-4 ${
                                  selectedSubjects.includes(sub.code)
                                    ? "bg-green-600 m-1 font-montserrat text-white text-lg"
                                    : "bg-green-100 m-1 font-montserrat text-green-900 text-lg"
                                } px-4 py-2`}
                                onClick={() => handleSubjectChange(sub.code)}
                              >
                                {sub.class}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </details>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex-row gap-5 ml-5 mb-5">
                <button
                  onClick={handleSearch}
                  className="text-white px-6 py-2 rounded bg-green-600 duration-300 font-roboto text-xl"
                >
                  Search
                </button>
                <button
                  onClick={clearFilters}
                  className="text-green-900 ml-5 px-6 py-2 rounded bg-green-100 duration-300 font-roboto text-xl"
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2 w-full p-5  bg-green-100">
        {jobs.reverse().map((job) => (
          <div className="containerDetails z-0 relative rounded-xl bg-white lg:h-[385px] sm:h-[395px]  p-5">
          <img
            alt=""
            className="w-36 absolute bottom-20 right-10 opacity-5"
            src="data:image/svg+xml;base64,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"
          />

          {/* Overlay */}
          <div className="overlay absolute top-0 left-0 w-full  bg-green-400 opacity-50"></div>

          {/* Text */}
          <div className=" flex flex-col justify-between text absolute top-0 left-0 p-6 z-10 text-white w-[100%] h-[100%]">
            <div className="w-full rounded-xl">
              <h1 className="text-xl cardTittle font-montserrat text-green-900">
                Need Tutor {classMapping[job.class] || job.class} Year
                Student-{job.teachingDays} Days/Week
              </h1>
              <div className="w-[50%] flex flex-row justify-between mt-6">
                <h1 className="text-md text-green-700 font-montserrat">
                  Job ID :{" "}
                  <span className="jobIdPostedDate">{job.jobId}</span>
                </h1>
                <h1 className="text-md text-green-700 font-montserrat">
                  |
                </h1>
                <h1 className="text-md text-green-700 font-montserrat">
                  Posted Date :{" "}
                  <span className="jobIdPostedDate">
                    {dateFormat(job.filterDate)}
                  </span>
                </h1>
              </div>
              <div className="mt-6 grid lg:grid-cols-3 sm:grid-cols-2 gap-5">
                <div className="flex flex-row gap-2">
                  <div>
                    <img
                      className="w-6 h-6"
                      src="data:image/svg+xml;base64,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"
                    />
                  </div>
                  <div>
                    <h1 className="font-montserrat text-green-900 text-md type">
                      Tuition Type
                    </h1>
                    <h1 className="font-montserrat text-green-900 text-md tutoring">
                      {addSpaceBeforeCapital(job.category)}
                    </h1>
                  </div>
                </div>
                <div className="flex flex-row gap-2">
                  <div>
                    <img
                      className="w-6 h-6"
                      src="data:image/svg+xml;base64,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"
                    />{" "}
                  </div>
                  <div>
                    <h1 className="font-montserrat text-green-900 text-md type">
                      Salary
                    </h1>
                    <h1 className="font-montserrat text-green-900 text-md tutoring">
                      {job.salary}
                    </h1>
                  </div>
                </div>

                <div className="flex flex-row gap-2">
                  <div>
                    <img
                      className="w-6 h-6"
                      src="data:image/svg+xml;base64,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"
                    />{" "}
                  </div>
                  <div>
                    <h1 className="font-montserrat text-green-900 text-md type">
                      Location
                    </h1>
                    <h1 className="font-montserrat text-green-900 text-md tutoring">
                      {job.ciy} {job.area}
                    </h1>
                  </div>
                </div>
                <div className="flex flex-row gap-2">
                  <div>
                    <img
                      className="w-7 h-7"
                      src="data:image/svg+xml;base64,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"
                    />{" "}
                  </div>
                  <div>
                    <h1 className="font-montserrat text-green-900 text-md type">
                      Subjects
                    </h1>
                    <h1 className="font-montserrat text-green-900 text-md tutoring">
                      {job.requiredSubject1}{" "}
                      {job.requiredSubject2 ? "," : ""}{" "}
                      {job.requiredSubject2}{" "}
                      {job.requiredSubject3 ? "," : ""}{" "}
                      {job.requiredSubject3}{" "}
                      {job.requiredSubject4 ? "," : ""}{" "}
                      {job.requiredSubject4}{" "}
                      {job.requiredSubject5 ? "," : ""}{" "}
                      {job.requiredSubject5}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Link to={`/dashboardTwo/jobsDetails/${job._id}`}>
                <div className="flex justify-end  w-full items-center mt-3">
                  <button className="px-4 py-2 rounded bg-green-600 hover:bg-green-900 duration-300 text-white font-montserrat">
                    Details
                  </button>
                </div>
              </Link>
            </div>
          </div>
        </div>
        ))}
      </div>
      <div className="flex justify-center items-start mb-12">
        <div className="flex justify-between mt-5 w-[300px]">
          <button
            onClick={handlePreviousPage}
            disabled={page === 1}
          >
            <img className="w-10" alt="" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGcgdHJhbnNmb3JtPSJtYXRyaXgoLTEsLTEuMjI0NjQ2Nzk5MTQ3MzUzMmUtMTYsMS4yMjQ2NDY3OTkxNDczNTMyZS0xNiwtMSw1MTIsNTEyKSI+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4=" />
          </button>
          <span className="text-lg font-roboto">
            Page {page} of {totalPages}
          </span>
          <button
            onClick={handleNextPage}
            disabled={page === totalPages}
            
          >
            <img className="w-10" alt="" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4=" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default JobsGreen;
